module.exports = __webpack_public_path__ + "static/media/hands_up_high_somatic_exercise.764e3e17.webp";